import {Component, Inject, Input} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {passwordMatchValidator} from "../form-validators";

export namespace ChangePasswordForm {
  export const FIELD_PASSWORD = "password"
  export const FIELD_CONFIRM = "confirm"
}

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html'
})
export class ChangePasswordFormComponent {
  @Input() submitting = false

  ChangePasswordForm = ChangePasswordForm

  passwordMinLength = 6
  form = new FormGroup({
    [ChangePasswordForm.FIELD_PASSWORD]: new FormControl(null, [
      Validators.required,
      Validators.minLength(this.passwordMinLength)
    ]),
    [ChangePasswordForm.FIELD_CONFIRM]: new FormControl(null, [Validators.required]),
  }, {
    validators: passwordMatchValidator(
      ChangePasswordForm.FIELD_PASSWORD,
      ChangePasswordForm.FIELD_CONFIRM
    )
  })

  constructor(
    private readonly dialogRef: MatDialogRef<ChangePasswordFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: {}
  ) {}

  onSubmit() {
    if (this.form.invalid) return
    const password = this.form.value[ChangePasswordForm.FIELD_PASSWORD] as string
    this.dialogRef.close({ password })
  }

  onCancel() {
    this.dialogRef.close()
  }
}
